import React, { useState } from 'react';
import { Row, Col, Modal, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet';


const Gallery = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    '/images/galery1.jpg',
    '/images/galery2.jpg',
    '/images/galery3.jpg',
    '/images/galery4.jpg',
    '/images/galery5.jpg',
    '/images/galery6.jpg',
    '/images/galery7.jpg',
    '/images/galery8.jpg',
    '/images/galery9.jpg',
    '/images/galery10.jpg',
    '/images/galery11.jpg',
    '/images/galery12.jpg',
    '/images/galery13.jpg',
    '/images/galery14.jpg',
    '/images/galery15.jpg',
    '/images/galery16.jpg'  
  ];

  const openModal = (index) => {
    setSelectedImage(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const nextImage = () => {
    setSelectedImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setSelectedImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div>
      <Helmet>
      <title>Галерея</title>
        <meta name="description" content="МЕБЕЛЬ ИЗ ВЫСОКОКАЧЕСТВЕННОЙ НЕРЖАВЕЮЩЕЙ СТАЛИ AISI 304 И AISI 430, оборудование для кухни, комплексное оснащение гостиниц и ресторанов, HORECA, Kromsan" />
      </Helmet>
      <Row xs={5} md={4} lg={4} className="g-4 mx-auto mb-4 mt-1" >
        {images.map((image, index) => (
          <Col key={index}>
            <Image 
              src={image}
              alt={`Image ${index}`}
              className="img-fluid"
              style={{ cursor: 'pointer' }}
              onClick={() => openModal(index)}
            />
          </Col>
        ))}
      </Row>

      <Modal size="xl" show={showModal} onHide={closeModal} centered>
        <Modal.Body>
          <Image
            src={images[selectedImage]}
            alt={`Image ${selectedImage}`}
            width="100%"
            className="img-fluid"
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={prevImage}>
            &lt; Previous
          </button>
          <button className="btn btn-secondary" onClick={nextImage}>
            Next &gt;
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Gallery;